import React from 'react';
import { Container } from 'react-bootstrap';

const Success = () => {
    return (
        <Container className="py-5 mt-5">
            <h2 className="metal-font display-6 text-center pb-3">
                Thank you for admission
            </h2>
        </Container>
    );
};

export default Success;